import React from "react";
import { FaArrowRight, FaShieldAlt } from "react-icons/fa";

const HeroSection = () => {
  return (
    <section className="relative bg-white text-black font-sans min-h-[80vh] flex items-center overflow-hidden selection:bg-black selection:text-white">

      {/* Subtle dotted texture */}
      <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(0,0,0,0.04)_1px,transparent_1px)] bg-[size:22px_22px] [mask-image:radial-gradient(ellipse_70%_60%_at_50%_40%,#000_55%,transparent_100%)]"></div>

      <div className="relative container mx-auto px-6 pt-[110px] pb-16 flex flex-col items-center text-center max-w-3xl z-10">

        {/* Label */}
        <span className="inline-flex items-center gap-2 px-4 py-1.5 mb-8 rounded-full border border-gray-200 text-xs font-medium tracking-wide uppercase text-gray-600">
          <span className="relative flex h-1.5 w-1.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-black/40"></span>
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-black"></span>
          </span>
          SEBI Registered Advisory
        </span>

        {/* Headline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-semibold leading-[1.05] tracking-tight mb-6">
          Master the Market
          <br />
          <span className="text-[#1e6091]">Confidently.</span>
        </h1>

        {/* Description */}
        <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-xl mb-10">
          Elevate your portfolio with powerful, abstract insights. Get premium
          advisory services designed to maximize your potential and secure your
          financial future.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a
            href="/contact"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-2 bg-[#1e6091] text-white text-sm font-medium tracking-wide px-8 py-4 rounded-full shadow-sm transition-all duration-200 hover:shadow-md hover:bg-[#185076]"
          >
            Get Started
            <FaArrowRight className="text-xs transition-transform duration-200 group-hover:translate-x-1" />
          </a>

          {/* <a
            href="https://wa.me/919082280240?text=Hi%20there!%20I%20want%20to%20know%20more%20about%20your%20services."
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-2.5 bg-white text-black text-sm font-medium tracking-wide px-8 py-4 rounded-full border border-gray-200 transition-all duration-200 hover:border-black hover:shadow-md"
          >
            View Packages
            <FaArrowRight className="text-xs text-gray-400 transition-all duration-200 group-hover:text-black group-hover:translate-x-1" />
          </a> */}
        </div>

        {/* Trust line */}
        <div className="mt-12 flex items-center gap-2 text-xs text-gray-500">
          <FaShieldAlt className="text-gray-400" />
          <span>SEBI Registered · Trusted Research-Backed Advisory</span>
        </div>

      </div>
    </section>
  );
};

export default HeroSection;
